export const THEME_STORAGE_KEY = 'theme-mode'
export const THEME_APP_ATTRIBUTE = 'data-theme'

export const themesEnum = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark',
})
